import { createRouter } from '@tarojs/taro'
import component from "./app"
import { createReactApp, window } from '@tarojs/runtime'
import { defineCustomElements, applyPolyfills } from '@tarojs/components/loader'

import * as React from 'react'
import ReactDOM from 'react-dom'

import '@tarojs/components/dist/taro-components/taro-components.css'

applyPolyfills().then(function () {
  defineCustomElements(window)
})

var config = {"router":{"mode":"browser"},"pages":["pages/home","pages/home/location","pages/my-order","pages/item","pages/search","pages/final-video","pages/final-video-list","pages/me","pages/me/info","pages/me/address","pages/me/setting","pages/me/address/detail","pages/me/shop-certification","pages/me/certification-results","pages/me/my-shop","pages/order","pages/order/remarks","pages/order/invoice","pages/order/invoice/detail","pages/order/pay","pages/login","pages/login/code","pages/login/password","pages/login/use-license","pages/login/secret-license","pages/login/shop-select","pages/final-video/feedback","pages/final-video/feedback/detail","pages/hunter/secret-license","pages/hunter/use-license","pages/hunter/about-license","pages/hunter/stardand-license","pages/service","pages/coupon","pages/coupon/exchange","pages/coupon/explain","pages/shop-cart","pages/download","pages/app-promote","pages/rate","pages/action-result/paySuccess","pages/action-result/ordeConfirmSuccess","pages/action-result/rateSuccess","pages/invoice","pages/invoice/detail","pages/invoice/result","pages/home/active-page","pages/marketing/message","pages/case/caseVideoDetail","pages/case","pages/invitation","pages/invitation/rule","pages/withdraw","pages/withdraw/record","pages/invite-record","pages/invitation/active-list","pages/me/help","pages/shoot-info","pages/categories","pages/order/pay-success","pages/service-progress","pages/server-order","pages/add-address","pages/action-result/subscribe-success","pages/shoot-info/appointment","pages/action-result/serviceIsBooked","pages/asset","pages/asset/detail","pages/commodity-share","pages/action-result/submitSuccess","pages/commodity-list","pages/equity-list","pages/merchant-entry","pages/merchant-list","pages/merchant-log","pages/merchant-search","pages/merchant-follow-list","pages/select-material"],"window":{"backgroundTextStyle":"light","navigationBarBackgroundColor":"#fff","navigationBarTitleText":"WeChat","navigationBarTextStyle":"black"},"tabBar":{"color":"#bbb","selectedColor":"#232323","backgroundColor":"#fff","borderStyle":"black","list":[{"pagePath":"/pages/home","iconPath":"./assets/home_unselected.png","selectedIconPath":"./assets/home_selected.png","text":"首页"},{"pagePath":"/pages/categories","iconPath":"./assets/icon_case@2x.png","selectedIconPath":"./assets/icon_case_selected@2x.png","text":"全部产品"},{"pagePath":"/pages/my-order","iconPath":"./assets/order_unselected.png","selectedIconPath":"./assets/order_selected.png","text":"订单"},{"pagePath":"/pages/me","iconPath":"./assets/me_unselected.png","selectedIconPath":"./assets/me_selected.png","text":"我的"}]}}
window.__taroAppConfig = config
var tabbarIconPath = []
var tabbarSelectedIconPath = []
tabbarIconPath[0] = require("./assets/home_unselected.png").default
tabbarSelectedIconPath[0] = require("./assets/home_selected.png").default
tabbarIconPath[1] = require("./assets/icon_case@2x.png").default
tabbarSelectedIconPath[1] = require("./assets/icon_case_selected@2x.png").default
tabbarIconPath[2] = require("./assets/order_unselected.png").default
tabbarSelectedIconPath[2] = require("./assets/order_selected.png").default
tabbarIconPath[3] = require("./assets/me_unselected.png").default
tabbarSelectedIconPath[3] = require("./assets/me_selected.png").default

if (config.tabBar) {
  var tabbarList = config.tabBar.list
  for (let i = 0; i < tabbarList.length; i++) {
    var t = tabbarList[i]
    if (t.iconPath) {
      t.iconPath = tabbarIconPath[i]
    }
    if (t.selectedIconPath) {
      t.selectedIconPath = tabbarSelectedIconPath[i]
    }
  }
}
config.routes = [
  
  Object.assign({
      path: 'pages/home',
      load: function() {
          return import("./pages/home")
      }
  }, require("./pages/home/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/home/location',
      load: function() {
          return import("./pages/home/location")
      }
  }, require("./pages/home/location/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/my-order',
      load: function() {
          return import("./pages/my-order")
      }
  }, require("./pages/my-order/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/item',
      load: function() {
          return import("./pages/item")
      }
  }, require("./pages/item/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/search',
      load: function() {
          return import("./pages/search")
      }
  }, require("./pages/search/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/final-video',
      load: function() {
          return import("./pages/final-video")
      }
  }, require("./pages/final-video/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/final-video-list',
      load: function() {
          return import("./pages/final-video-list")
      }
  }, require("./pages/final-video-list/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/me',
      load: function() {
          return import("./pages/me")
      }
  }, require("./pages/me/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/me/info',
      load: function() {
          return import("./pages/me/info")
      }
  }, require("./pages/me/info/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/me/address',
      load: function() {
          return import("./pages/me/address")
      }
  }, require("./pages/me/address/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/me/setting',
      load: function() {
          return import("./pages/me/setting")
      }
  }, require("./pages/me/setting/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/me/address/detail',
      load: function() {
          return import("./pages/me/address/detail")
      }
  }, require("./pages/me/address/detail/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/me/shop-certification',
      load: function() {
          return import("./pages/me/shop-certification")
      }
  }, require("./pages/me/shop-certification/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/me/certification-results',
      load: function() {
          return import("./pages/me/certification-results")
      }
  }, require("./pages/me/certification-results/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/me/my-shop',
      load: function() {
          return import("./pages/me/my-shop")
      }
  }, require("./pages/me/my-shop/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/order',
      load: function() {
          return import("./pages/order")
      }
  }, require("./pages/order/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/order/remarks',
      load: function() {
          return import("./pages/order/remarks")
      }
  }, require("./pages/order/remarks/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/order/invoice',
      load: function() {
          return import("./pages/order/invoice")
      }
  }, require("./pages/order/invoice/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/order/invoice/detail',
      load: function() {
          return import("./pages/order/invoice/detail")
      }
  }, require("./pages/order/invoice/detail/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/order/pay',
      load: function() {
          return import("./pages/order/pay")
      }
  }, require("./pages/order/pay/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/login',
      load: function() {
          return import("./pages/login")
      }
  }, require("./pages/login/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/login/code',
      load: function() {
          return import("./pages/login/code")
      }
  }, require("./pages/login/code/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/login/password',
      load: function() {
          return import("./pages/login/password")
      }
  }, require("./pages/login/password/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/login/use-license',
      load: function() {
          return import("./pages/login/use-license")
      }
  }, require("./pages/login/use-license/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/login/secret-license',
      load: function() {
          return import("./pages/login/secret-license")
      }
  }, require("./pages/login/secret-license/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/login/shop-select',
      load: function() {
          return import("./pages/login/shop-select")
      }
  }, require("./pages/login/shop-select/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/final-video/feedback',
      load: function() {
          return import("./pages/final-video/feedback")
      }
  }, require("./pages/final-video/feedback/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/final-video/feedback/detail',
      load: function() {
          return import("./pages/final-video/feedback/detail")
      }
  }, require("./pages/final-video/feedback/detail/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/hunter/secret-license',
      load: function() {
          return import("./pages/hunter/secret-license")
      }
  }, require("./pages/hunter/secret-license/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/hunter/use-license',
      load: function() {
          return import("./pages/hunter/use-license")
      }
  }, require("./pages/hunter/use-license/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/hunter/about-license',
      load: function() {
          return import("./pages/hunter/about-license")
      }
  }, require("./pages/hunter/about-license/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/hunter/stardand-license',
      load: function() {
          return import("./pages/hunter/stardand-license")
      }
  }, require("./pages/hunter/stardand-license/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/service',
      load: function() {
          return import("./pages/service")
      }
  }, require("./pages/service/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/coupon',
      load: function() {
          return import("./pages/coupon")
      }
  }, require("./pages/coupon/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/coupon/exchange',
      load: function() {
          return import("./pages/coupon/exchange")
      }
  }, require("./pages/coupon/exchange/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/coupon/explain',
      load: function() {
          return import("./pages/coupon/explain")
      }
  }, require("./pages/coupon/explain/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/shop-cart',
      load: function() {
          return import("./pages/shop-cart")
      }
  }, require("./pages/shop-cart/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/download',
      load: function() {
          return import("./pages/download")
      }
  }, require("./pages/download/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/app-promote',
      load: function() {
          return import("./pages/app-promote")
      }
  }, require("./pages/app-promote/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/rate',
      load: function() {
          return import("./pages/rate")
      }
  }, require("./pages/rate/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/action-result/paySuccess',
      load: function() {
          return import("./pages/action-result/paySuccess")
      }
  }, require("./pages/action-result/paySuccess/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/action-result/ordeConfirmSuccess',
      load: function() {
          return import("./pages/action-result/ordeConfirmSuccess")
      }
  }, require("./pages/action-result/ordeConfirmSuccess/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/action-result/rateSuccess',
      load: function() {
          return import("./pages/action-result/rateSuccess")
      }
  }, require("./pages/action-result/rateSuccess/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/invoice',
      load: function() {
          return import("./pages/invoice")
      }
  }, require("./pages/invoice/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/invoice/detail',
      load: function() {
          return import("./pages/invoice/detail")
      }
  }, require("./pages/invoice/detail/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/invoice/result',
      load: function() {
          return import("./pages/invoice/result")
      }
  }, require("./pages/invoice/result/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/home/active-page',
      load: function() {
          return import("./pages/home/active-page")
      }
  }, require("./pages/home/active-page/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/marketing/message',
      load: function() {
          return import("./pages/marketing/message")
      }
  }, require("./pages/marketing/message/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/case/caseVideoDetail',
      load: function() {
          return import("./pages/case/caseVideoDetail")
      }
  }, require("./pages/case/caseVideoDetail/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/case',
      load: function() {
          return import("./pages/case")
      }
  }, require("./pages/case/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/invitation',
      load: function() {
          return import("./pages/invitation")
      }
  }, require("./pages/invitation/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/invitation/rule',
      load: function() {
          return import("./pages/invitation/rule")
      }
  }, require("./pages/invitation/rule/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/withdraw',
      load: function() {
          return import("./pages/withdraw")
      }
  }, require("./pages/withdraw/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/withdraw/record',
      load: function() {
          return import("./pages/withdraw/record")
      }
  }, require("./pages/withdraw/record/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/invite-record',
      load: function() {
          return import("./pages/invite-record")
      }
  }, require("./pages/invite-record/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/invitation/active-list',
      load: function() {
          return import("./pages/invitation/active-list")
      }
  }, require("./pages/invitation/active-list/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/me/help',
      load: function() {
          return import("./pages/me/help")
      }
  }, require("./pages/me/help/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/shoot-info',
      load: function() {
          return import("./pages/shoot-info")
      }
  }, require("./pages/shoot-info/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/categories',
      load: function() {
          return import("./pages/categories")
      }
  }, require("./pages/categories/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/order/pay-success',
      load: function() {
          return import("./pages/order/pay-success")
      }
  }, require("./pages/order/pay-success/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/service-progress',
      load: function() {
          return import("./pages/service-progress")
      }
  }, require("./pages/service-progress/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/server-order',
      load: function() {
          return import("./pages/server-order")
      }
  }, require("./pages/server-order/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/add-address',
      load: function() {
          return import("./pages/add-address")
      }
  }, require("./pages/add-address/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/action-result/subscribe-success',
      load: function() {
          return import("./pages/action-result/subscribe-success")
      }
  }, require("./pages/action-result/subscribe-success/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/shoot-info/appointment',
      load: function() {
          return import("./pages/shoot-info/appointment")
      }
  }, require("./pages/shoot-info/appointment/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/action-result/serviceIsBooked',
      load: function() {
          return import("./pages/action-result/serviceIsBooked")
      }
  }, require("./pages/action-result/serviceIsBooked/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/asset',
      load: function() {
          return import("./pages/asset")
      }
  }, require("./pages/asset/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/asset/detail',
      load: function() {
          return import("./pages/asset/detail")
      }
  }, require("./pages/asset/detail/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/commodity-share',
      load: function() {
          return import("./pages/commodity-share")
      }
  }, require("./pages/commodity-share/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/action-result/submitSuccess',
      load: function() {
          return import("./pages/action-result/submitSuccess")
      }
  }, require("./pages/action-result/submitSuccess/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/commodity-list',
      load: function() {
          return import("./pages/commodity-list")
      }
  }, require("./pages/commodity-list/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/equity-list',
      load: function() {
          return import("./pages/equity-list")
      }
  }, require("./pages/equity-list/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/merchant-entry',
      load: function() {
          return import("./pages/merchant-entry")
      }
  }, require("./pages/merchant-entry/index.config").default || {}),

  Object.assign({
      path: 'pages/merchant-list',
      load: function() {
          return import("./pages/merchant-list")
      }
  }, require("./pages/merchant-list/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/merchant-log',
      load: function() {
          return import("./pages/merchant-log")
      }
  }, require("./pages/merchant-log/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/merchant-search',
      load: function() {
          return import("./pages/merchant-search")
      }
  }, require("./pages/merchant-search/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/merchant-follow-list',
      load: function() {
          return import("./pages/merchant-follow-list")
      }
  }, require("./pages/merchant-follow-list/index.config.ts").default || {}),

  Object.assign({
      path: 'pages/select-material',
      load: function() {
          return import("./pages/select-material")
      }
  }, require("./pages/select-material/index.config.ts").default || {}),

]

var inst = createReactApp(component, React, ReactDOM, config)
createRouter(inst, config, React)
